import React, { useState } from 'react';

interface Image {
  id: number;
  src: string;
  alt: string;
}

interface ProductGalleryProps {
  images: Image[];
}

const ProductGallery: React.FC<ProductGalleryProps> = ({ images }) => {
  const [activeImage, setActiveImage] = useState<number>(0);

  return (
    <div className="w-full md:w-1/2 lg:w-3/5 flex flex-col">
      <div className="relative overflow-hidden rounded-lg mb-4 bg-gray-50 aspect-[4/3]">
        <img
          src={images[activeImage]?.src}
          alt={images[activeImage]?.alt}
          className="w-full h-full object-cover transition-opacity duration-300"
        />
      </div>

      <div className="flex space-x-3 overflow-x-auto pb-2">
        {images.map((image, index) => (
          <button
            key={image.id}
            onClick={() => setActiveImage(index)}
            className={`relative min-w-16 h-16 rounded-md overflow-hidden border-2 transition-all ${activeImage === index ? 'border-black' : 'border-gray-200'
              }`}
          >
            <img
              src={image.src}
              alt={`Thumbnail ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;